export const Models = {
  get Field() {
    return {
      region: null,
      crop: false,
      rect: true,
      rectOut: false,
      selected: false,
      naturalWith: 0,
      naturalHeight: 0,
      clientWidth: 0,
      clientHeight: 0,
      id: Math.floor(Math.random() * 1000000),
      zIndex: 20,
      color: "black",
      colorBorder: "black"
    };
  },
  get Region() {
    return {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
      rx: 0,
      ry: 0,
      rw: 0,
      rh: 0,
      naturalWidth: 0,
      naturalHeight: 0,
      clientWidth: 0,
      clientHeight: 0,
      rgba: { r: 0, g: 0, b: 0, a: 1 }
    };
  },
  get Batch() {
    return {
      Name: "",
      Date: "",
      Exported: false,
      Id: "",
      Path: "",
      RootPath: "",
      Images: [],
      Documents: [],
      Attachments: [],
      IndexCount: 0,
      IndexCountDoc: 0,
      Type: "Default Batch Type",
      UploadStatus: false,
      SessionId: ""
    };
  },
  get Document() {
    return {
      Expanded: true,
      Locked: false,
      AttachmentName: "",
      Name: "",
      Exported: false,
      Id: "",
      Path: "",
      Images: [],
      Index: 0,
      Load: false,
      ReqId: 0,
      DocClass: null,
      Indexes: [],
      FileId: ""
    };
  },
  get ImageScan() {
    return {
      Locked: false,
      Marked: false,
      SrcName: "",
      AttachmentName: "",
      Name: "",
      Date: "",
      comment: "",
      Exported: false,
      Path: "",
      Base64: "",
      Base64Full: "",
      Type: "SCAN",
      Index: 0,
      ReqId: 0,
      IsMobile: false,
      filterId: "",
      Load: false,
      DocName: "",
      DocId: "",
      DocClass: null,
      PixelFormat: "",
      Indexes: [],
      Rotation: 0
    };
  },
  get Action() {
    return {
      TYPE: "",
      MondayContext: null,
      Batch: null,
      BatchType: null,
      Extensions: null,
      Document: null,
      SimSettings: null,
      MobileScanLinks: [],
      MobileId: "",
      IsMobileScan: false,
      EndpointSettings: null,
      ImportProfile: null,
      Data: null,
      ExtractData: [],
      User: null,
      Image: null,
      Images: null,
      ListBatches: [],
      Transform: null,
      Separator: false,
      BarcodeSeparator: false,
      BarcodeModel: "",
      Progress: null,
      UploadProfil: null,
      Params: null,
      Devices: null,
      Device: null,
      StatusCode: 200,
      StatusMessage: "",
      LicenseStatus: 1,
      LicenseExpireDate: "",
      AppSettings: null,
      DocClass: null,
      ExportEndpointSettings: null,
      BatchTypes: null,
      SessionId: "",
      Quick: false,
      Logo: "",
      Icon: "",
      NoNotification: false,
      Offline: false,
      OfflineResponseData: "",
      IsOfflineLicense: false,
      OfflineRequestDeactivationData: "",
      OfflineResponseDeactivationData: "",
      LicenseType: "node-locked"
    };
  },
  get BatchUploadProfil() {
    return {
      Params: [],
      BatchProperties: [],
      Classes: [],
      Indexes: [],
      Settings: [],
      ExportEndPoint: [],
      Quick: false,
      SessionId: "",
      StatusBar: { Color: "primary lighten1", Info: "" }
    };
  },
  get UploadParam() {
    return { Name: "", Value: "" };
  },
  get DocClass() {
    return { Id: 0, Name: "", Value: "", Default: false };
  },
  get ListBatchItem() {
    return {
      Name: "",
      Path: "",
      Id: "",
      RootPath: "",
      Date: "",
      Type: "",
      UploadStatus: false,
      IndexCount: 0,
      IndexCountDoc: 0,
      TotalPages: 0,
      TotalDocs: 0
    };
  },
  get Device() {
    return {
      Name: "",
      Id: 0,
      CanDuplex: false,
      Duplex: false,
      DPI: 0,
      Depth: "",
      Size: "",
      BarcodeSeparator: false,
      BarcodeRegexp: "",
      BarcodeModel: "",
      AutoSinglePageDocuments: true,
      AutoSeparator: false,
      BarcodeDirection: "SDTREADDIRECTION_ALL",
      BarcodeArea: "FULL"
    };
  },
  get DocIndex() {
    return {
      Id: 0,
      Name: "",
      Caption: "",
      Value: "",
      DataType: "String",
      CurrentDate: false,
      Mandatory: false
    };
  },
  get DocIndexDataTypes() {
    return ["Date", "Number", "String"];
  },
  get AppSettingsTypes() {
    return [
      "Duplex",
      "DPI",
      "Depth",
      "Size",
      "BarcodeSeparator",
      "BarcodeRegexp",
      "BarcodeModel",
      "AutoSeparator",
      "AutoSinglePageDocuments",
      "BarcodeDirection",
      "BarcodeArea",
      "BatchDeleteTime",
      "ImportFolder",
      "Attachments",
      "ExportFolder",
      "Format",
      "Quality",
      "Depth",
      "Compression",
      "Skip"
      /* 'AutoSave' */
    ];
  },
  get AppSettingsTypesObj() {
    return [
      { name: "appBatchDeleteTime", value: "BatchDeleteTime" },
      { name: "appDuplex", value: "Duplex" },
      { name: "appDPI", value: "DPI" },
      { name: "appDepth", value: "Depth" },
      { name: "appSize", value: "Size" },
      { name: "appBarcodeSeparator", value: "BarcodeSeparator" },
      { name: "appBarcodeRegexp", value: "BarcodeRegexp" },
      { name: "appBarcodeModel", value: "BarcodeModel" },
      { name: "appAutoSeparator", value: "AutoSeparator" },
      { name: "appAutoSinglePageDocuments", value: "AutoSinglePageDocuments" },
      { name: "appFileSeparator", value: "FileSeparator" },
      { name: "appBarcodeDirection", value: "BarcodeDirection" },
      { name: "appBarcodeArea", value: "BarcodeArea" },
      { name: "appImportFolder", value: "ImportFolder" },
      { name: "appAttachments", value: "Attachments" },
      { name: "appExportFolder", value: "ExportFolder" },
      { name: "appExportFormat", value: "ExportSettingsFormat" },
      { name: "appExportQuality", value: "ExportSettingsQuality" },
      { name: "appExportColor", value: "ExportSettingsDepth" },
      { name: "appExportCompression", value: "ExportSettingsCompression" },
      { name: "appExportSkip", value: "ExportSettingsSkip" }
    ];
  },
  get AppEndpointSettingsTypes() {
    return [
      "Endpoint",
      "Type",
      "ConfirmDialog",
      "SessionID",
      "AUTH",
      "Headers"
    ];
  },
  get AppSettings() {
    const exportSettings = {
      Format: "PDF",
      Depth: "BlackWhite",
      Quality: 10,
      Compression: "Group4"
    };
    return {
      ExportFolder: "",
      ExportSettings: exportSettings,
      BatchDeleteTime: 14,
      ImportFolder: "",
      Duplex: false,
      DPI: 300,
      Depth: "BlackWhite",
      Size: "A4",
      BarcodeSeparator: false,
      BarcodeRegexp: "",
      BarcodeModel: "ALL_1D",
      AutoSinglePageDocuments: true,
      AutoSeparator: false,
      BarcodeDirection: "SDTREADDIRECTION_LTR",
      BarcodeArea: "TOP_1_3",
      ForceUrl: false
    };
  },
  get AppSetting() {
    return { Id: 0, Name: "", Value: "", DataType: "string" };
  },
  get ExportEndpointSettings() {
    return { Endpoint: "", Type: "", Params: [] };
  },
  get ImgTransform() {
    return {
      ROTATE_LEFT: "ROTATE_LEFT",
      ROTATE_RIGHT: "ROTATE_RIGHT",
      RotationType: "",
      Rotation: 0
    };
  },
  copyIndexes(indexes) {
    const arr = [];
    indexes.forEach(e => {
      const idc = this.DocIndex;
      idc.Id = Math.floor(Math.random() * 1000000);
      idc.Name = e.Name;
      idc.CurrentDate = e.CurrentDate;
      idc.Mandatory = e.Mandatory;
      idc.Caption = e.Caption;
      idc.Value = e.Value;
      idc.DataType = e.DataType;
      arr.push(idc);
    });
    return arr;
  },
  ToBatchListItem(batch) {
    const item = {
      Name: "",
      Path: "",
      Id: "",
      RootPath: "",
      Date: "",
      Type: "",
      UploadStatus: false,
      IndexCount: 0,
      IndexCountDoc: 0,
      TotalPages: 0,
      TotalDocs: 0
    };
    item.Name = batch.Name;
    item.Path = batch.Path;
    item.Id = batch.Id;
    item.RootPath = "";
    item.Date = batch.Date;
    item.UploadStatus = batch.UploadStatus;
    item.Type = batch.Type;
    item.IndexCount = batch.IndexCount;
    item.IndexCountDoc = batch.IndexCountDoc;
    item.TotalPages = batch.TotalPages;
    item.TotalDocs = batch.TotalDocs;
    return item;
  },
  get ActionType() {
    return {
      SCAN: "SCAN",
      MOBILE_SCAN: "MOBILE_SCAN",
      MOBILE_RESCAN: "MOBILE_RESCAN",
      UPLOAD_TO_MONDAY: "UPLOAD_TO_MONDAY",
      SAVE_MOBILESCAN_SETTINGS: "SAVE_MOBILESCAN_SETTINGS",
      MOBILE_SCAN_IMAGE_UPDATE: "MOBILE_SCAN_IMAGE_UPDATE",
      MOBILE_SCAN_REFRESH: "MOBILE_SCAN_REFRESH",
      CREATE_BATCH: "CREATE_BATCH",
      NEW_SCAN_IMAGE: "NEW_SCAN_IMAGE",
      NEW_SCAN_FROM_IMAGE: "NEW_SCAN_FROM_IMAGE",
      DELETE_SCAN_IMAGE: "DELETE_SCAN_IMAGE",
      DELETE_SCAN_IMAGE_RESPONSE: "DELETE_SCAN_IMAGE_RESPONSE",
      CREATE_DOCUMENT: "CREATE_DOCUMENT",
      CREATE_BATCH_RESPONSE: "CREATE_BATCH_RESPONSE",
      DEFAULT_BATCH: "DEFAULT_BATCH",
      SET_DEFAULT_BATCH: "SET_DEFAULT_BATCH",
      LIST_BATCHES: "LIST_BATCHES",
      LIST_BATCHES_UPDATE_ITEM: "LIST_BATCHES_UPDATE_ITEM",
      ADD_DOCUMENT: "ADD_DOCUMENT",
      UPDATE_DOCUMENTS: "UPDATE_DOCUMENTS",
      UPDATE_BATCH: "UPDATE_BATCH",
      INFO: "INFO",
      SYSTEM_INFO: "SYSTEM_INFO",
      UPLOAD_BATCH: "UPLOAD_BATCH",
      UPLOAD_BATCH_RESPONSE: "UPLOAD_BATCH_RESPONSE",
      UPLOAD_BATCH_PROGRESS: "UPLOAD_BATCH_PROGRESS",
      NEW_DOCUMENT: "NEW_DOCUMENT",
      EXTRACT_DOCUMENT: "EXTRACT_DOCUMENT",
      INSERT_USER: "INSERT_USER",
      UPDATE_USER: "UPDATE_USER",
      DELETE_USER: "DELETE_USER",
      LOGIN_USER: "LOGIN_USER",
      TWAIN_SOURCE_LIST: "TWAIN_SOURCE_LIST",
      TWAIN_SOURCE_RELOAD: "TWAIN_SOURCE_RELOAD",
      TWAIN_SOURCE_CAP: "TWAIN_SOURCE_CAP",
      WINDOWS_SCAN_GUI: "WINDOWS_SCAN_GUI",
      DRIVER_SETTINGS: "DRIVER_SETTINGS",
      SELECT_DIR: "SELECT_DIR",
      DELETE_BATCH: "DELETE_BATCH",
      LOGS: "LOGS",
      VERSION: "VERSION",
      ACTIVATION: "ACTIVATION",
      DEACTIVATION: "DEACTIVATION",
      LICENSE: "LICENSE",
      EDIT_IMAGE: "EDIT_IMAGE",
      LOAD_FULL_IMAGE: "LOAD_FULL_IMAGE",
      SYSTEM_ENV_PROCESS: "SYSTEM_ENV_PROCESS",
      EXPORT_BATCH_RESPONSE: "EXPORT_BATCH_RESPONSE",
      EXPORT_CANCEL_DIALOG: "EXPORT_CANCEL_DIALOG",
      SAVE_SIM_SETTINGS: "SAVE_SIM_SETTINGS",
      SAVE_ENDPOINT_SETTINGS: "SAVE_ENDPOINT_SETTINGS",
      SAVE_APP_SETTINGS: "SAVE_APP_SETTINGS",
      LOAD_APP_SETTINGS: "LOAD_APP_SETTINGS",
      CHANGE_LANG: "CHANGE_LANG",
      PROCESS_INFO: "PROCESS_INFO",
      KILL_PROCESS: "KILL_PROCESS",
      EXPORT_BATCH_ENDPOINT: "EXPORT_BATCH_ENDPOINT",
      IMPORT_FOLDER: "IMPORT_FOLDER",
      SAVE_BATCH_TYPES: "SAVE_BATCH_TYPES",
      SAVE_BATCH_TYPES_EXTENSION: "SAVE_BATCH_TYPES_EXTENSION",
      UPDATE_SELECTED_BATCH_TYPE: "UPDATE_SELECTED_BATCH_TYPE",
      LOAD_BATCH_TYPES: "LOAD_BATCH_TYPES",
      SIM_FILES: "SIM_FILES",
      SIM_FILES_DOWNLOAD: "SIM_FILES_DOWNLOAD",
      MONDAY_FILES_DOWNLOAD: "MONDAY_FILES_DOWNLOAD",
      MONDAY_FILES_DOWNLOAD_CONFIRM: "MONDAY_FILES_DOWNLOAD_CONFIRM",
      LIMIT: "LIMIT",
      OPEN_FILE: "OPEN_FILE",
      MFILES: "MFILES",
      MFILES_DOWNLOAD: "MFILES_DOWNLOAD",
      MFILES_DOWNLOAD_PROGRESS: "MFILES_DOWNLOAD_PROGRESS",
      MFILES_UPLOAD: "MFILES_UPLOAD",
      // ADIITIONAL ACTION RESERVED ONLY FOR ANALYTICS
      CREATE_DOCUMENT_SEPARATOR: "CREATE_DOCUMENT_SEPARATOR",
      ADD_TO_SINGLEPAGE_DOCS: "ADD_TO_SINGLEPAGE_DOCS",
      EXCLUDE_DOCUMENT: "EXCLUDE_DOCUMENT",
      EXCLUDE_DOCUMENT_SINGLEPAGE: "EXCLUDE_DOCUMENT_SINGLEPAGE",
      DELETE_DOCUMENT: "DELETE_DOCUMENT",
      CHANGE_BATCH: "CHANGE_BATCH",
      CHANGE_GRIDSIZE: "CHANGE_GRIDSIZE",
      CHANGE_VIEW: "CHANGE_VIEW",
      EDIT_DOCUMENT: "EDIT_DOCUMENT",
      EXPORT_BATCH: "EXPORT_BATCH",
      DOWNLOAD_SETUP: "DOWNLOAD_SETUP",
      RUN_APP: "RUN_APP"
    };
  },
  get VIEW() {
    return {
      BATCH_SCAN: "BATCH_SCAN",
      BATCH_LIST: "BATCH_LIST",
      JSON_GENERATOR: "JSON_GENERATOR"
    };
  },
  get VIEW_SCAN_TYPE() {
    return {
      SCAN: "SCAN",
      IMPORT: "IMPORT",
      QUICK_SCAN: "QUICK_SCAN"
    };
  },
  get LicenseStatus() {
    return {
      0: "LA_OK",
      57: "LA_E_OFFLINE_RESPONSE_FILE_EXPIRED",
      58: "LA_E_ACTIVATION_LIMIT",
      59: "LA_E_ACTIVATION_NOT_FOUND",
      60: "LA_E_DEACTIVATION_LIMIT",
      61: "LA_E_TRIAL_NOT_ALLOWED",
      62: "LA_E_TRIAL_ACTIVATION_LIMIT",
      63: "LA_E_MACHINE_FINGERPRINT",
      64: "LA_E_METADATA_KEY_LENGTH",
      65: "LA_E_METADATA_VALUE_LENGTH",
      66: "LA_E_ACTIVATION_METADATA_LIMIT",
      67: "LA_E_TRIAL_ACTIVATION_METADATA_LIMIT",
      68: "LA_E_METADATA_KEY_NOT_FOUND",
      69: "LA_E_TIME_MODIFIED",
      70: "LA_E_RELEASE_VERSION_FORMAT",
      71: "LA_E_AUTHENTICATION_FAILED",
      72: "LA_E_METER_ATTRIBUTE_NOT_FOUND",
      73: "LA_E_METER_ATTRIBUTE_USES_LIMIT_REACHED",
      80: "LA_E_VM",
      81: "LA_E_COUNTRY",
      82: "LA_E_IP",
      90: "LA_E_RATE_LIMIT",
      56: "LA_E_OFFLINE_RESPONSE_FILE",
      91: "LA_E_SERVER",
      55: "LA_E_LICENSE_TYPE",
      53: "LA_E_REVOKED",
      1: "LA_FAIL",
      20: "LA_EXPIRED",
      21: "LA_SUSPENDED",
      22: "LA_GRACE_PERIOD_OVER",
      25: "LA_TRIAL_EXPIRED",
      26: "LA_LOCAL_TRIAL_EXPIRED",
      30: "LA_RELEASE_UPDATE_AVAILABLE",
      31: "LA_RELEASE_NO_UPDATE_AVAILABLE",
      40: "LA_E_FILE_PATH",
      41: "LA_E_PRODUCT_FILE",
      42: "LA_E_PRODUCT_DATA",
      43: "LA_E_PRODUCT_ID",
      44: "LA_E_SYSTEM_PERMISSION",
      45: "LA_E_FILE_PERMISSION",
      46: "LA_E_WMIC",
      47: "LA_E_TIME",
      48: "LA_E_INET",
      49: "LA_E_NET_PROXY",
      50: "LA_E_HOST_URL",
      51: "LA_E_BUFFER_SIZE",
      52: "LA_E_APP_VERSION_LENGTH",
      54: "LA_E_LICENSE_KEY",
      92: "LA_E_CLIENT"
    };
  },
  get BarcodeTypes() {
    return [
      { name: "UNKNOWN", val: "SDTBARCODETYPE_UNKNOWN" },
      { name: "ALL_2D", val: "SDTBARCODETYPE_ALL_2D" },
      { name: "QRCODE", val: "SDTBARCODETYPE_QRCODE" },
      { name: "PDF417", val: "SDTBARCODETYPE_PDF417" },
      { name: "DATAMATRIX", val: "SDTBARCODETYPE_DATAMATRIX" },
      { name: "INTELLIMAIL", val: "SDTBARCODETYPE_INTELLIMAIL" },
      { name: "ALL_1D", val: "SDTBARCODETYPE_ALL_1D" },
      { name: "GS1DATABAR", val: "SDTBARCODETYPE_GS1DATABAR" },
      { name: "PHARMACODE", val: "SDTBARCODETYPE_PHARMACODE" },
      { name: "UPCE", val: "SDTBARCODETYPE_UPCE" },
      { name: "MSI", val: "SDTBARCODETYPE_MSI" },
      { name: "UPCB", val: "SDTBARCODETYPE_UPCB" },
      { name: "PLUS5", val: "SDTBARCODETYPE_PLUS5" },
      { name: "CODABAR", val: "SDTBARCODETYPE_CODABAR" },
      { name: "CODE128", val: "SDTBARCODETYPE_CODE128" },
      { name: "CODE32", val: "SDTBARCODETYPE_CODE32" },
      { name: "UPCA", val: "SDTBARCODETYPE_UPCA" },
      { name: "CODE93", val: "SDTBARCODETYPE_CODE93" },
      { name: "CODE11", val: "SDTBARCODETYPE_CODE11" },
      { name: "CODE39", val: "SDTBARCODETYPE_CODE39" },
      { name: "EAN8", val: "SDTBARCODETYPE_EAN8" },
      { name: "EAN5", val: "SDTBARCODETYPE_EAN5" },
      { name: "I2OF5", val: "SDTBARCODETYPE_I2OF5" },
      { name: "PATCH_CODE", val: "SDTBARCODETYPE_PATCH_CODE" },
      { name: "POSTNET", val: "SDTBARCODETYPE_POSTNET" },
      { name: "PLUS2", val: "SDTBARCODETYPE_PLUS2" },
      { name: "EAN13", val: "SDTBARCODETYPE_EAN13" }
    ];
  }
};
export default Models;
